module.exports = __webpack_public_path__ + "static/media/logo-gov.13f244fb.png";